import React, { useEffect, useMemo } from "react";
import { Button, Row, Col, Form } from "react-bootstrap";
import { MESSAGE } from "../../../utils/message";
import {
  CausePreferencesSection,
  FundraiserTitle,
  CauseSmallText,
  CausePreferencesFrom,
  FromButton,
} from "./causePreferencesStyle";
import { useDispatch, useSelector } from "react-redux";
import {
  CausePreferenceProps,
  UserCausePreferenceProps,
} from "../../../utils/types";
import {
  allCausePreferHandler,
  updateCausePreference,
  userCausePreferHandler,
} from "../../../redux/slices/myAccount/myCausePreference";
import { FieldArray, FormikProvider, useFormik } from "formik";
import { useParams } from "react-router-dom";
import * as Yup from "yup";
import { showErrorToast } from "../../../utils/toast";

const initValues: Array<string> = ["", "", "", "", ""];

// const validationSchema = Yup.object({
//   cause_list: Yup.array()
//     .of(Yup.string().trim().required("Cause selection is required"))
//     .min(1, "At least one cause must be selected")
//     .test(
//       "not-empty",
//       "All selected causes must be valid",
//       (value) => value?.every((item) => item?.trim() !== "") ?? false
//     ),
// });
const validationSchema = Yup.object({
  cause_list: Yup.array()
    .of(Yup.string().nullable())
    .test(
      "at-least-one",
      "At least one cause must be selected",
      (value) => Array.isArray(value) && value.some((item) => item?.trim() !== "")
    ),
});

const CausePreferences = () => {
  const dispatch = useDispatch();
  const { user_id } = useParams<{ user_id: string }>();
  const causePreferenceData = useSelector(
    (state: CausePreferenceProps) => state?.causePreference?.data?.results ?? []
  );
  const userCausePreferenceData = useSelector(
    (state: UserCausePreferenceProps) => state?.causePreference?.userData?.results ?? []
  );

  const cause_list = useMemo(() => {
    const tempValues = [...initValues];
    if (userCausePreferenceData?.length) {
      userCausePreferenceData.forEach(
        (item, i) => (tempValues[i] = JSON.stringify(item))
      );
    }
    return tempValues;
  }, [userCausePreferenceData]);

  useEffect(() => {
    if (user_id) {
      dispatch(userCausePreferHandler(user_id) as any);
    }
    dispatch(allCausePreferHandler() as any);
  }, [dispatch, user_id]);

  const formik = useFormik({
    initialValues: {
      cause_list: cause_list,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (values) => {
      const findCause = values.cause_list?.filter((item: any) => { return (item !== "") })
      if (findCause?.length > 0) {
        const filteredValues = values.cause_list.filter((item) => item?.trim() !== "");
        const tempValues = {
          cause_list: filteredValues.map((item) => JSON.parse(item)),
        };
        dispatch(updateCausePreference(user_id as string, tempValues) as any);
      } else {
        showErrorToast("Please select atleast one cause.")
      }
    },
    // onSubmit: (values) => {
    //   const tempValues = {
    //     cause_list: values.cause_list.map((item) => JSON.parse(item)),
    //   };
    //   dispatch(updateCausePreference(user_id as string, tempValues) as any);

    // },
  });

  return (
    <CausePreferencesSection>
      <FundraiserTitle>{MESSAGE.myCausePreferences}</FundraiserTitle>
      <CauseSmallText>{MESSAGE.causePreferenceText}</CauseSmallText>
      <CausePreferencesFrom>
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <FieldArray
                name="cause_list"
                render={() =>
                  formik.values?.cause_list?.map((item: any, index: number) => (
                    <Col key={"cause_" + index} sm={12} md={12} lg={6}>
                      <Form.Label>Cause {index + 1}</Form.Label>
                      <Form.Select
                        size="lg"
                        name={`cause_list[${index}]`}
                        value={formik.values?.cause_list[index] ?? ""}
                        onChange={(e) =>
                          formik.setFieldValue(
                            `cause_list[${index}]`,
                            e.target.value
                          )
                        }
                        isInvalid={Boolean(formik.errors.cause_list && !!formik.errors.cause_list[index])}
                      // isInvalid={!!formik.errors.cause_list?.[index]}
                      >
                        <option value="">Pick a Cause</option>
                        {causePreferenceData?.map(OptionItems)}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {formik.errors.cause_list?.[index]}
                      </Form.Control.Feedback>
                    </Col>
                  ))
                }
              />
            </Row>

            <FromButton>
              <Button type="submit" className="btn-outline-success-blue">
                Save Change
              </Button>
              <Button className="btn-outline" onClick={() => formik.resetForm()}>Cancel</Button>
            </FromButton>
          </Form>
        </FormikProvider>
      </CausePreferencesFrom>
    </CausePreferencesSection>
  );
};

const OptionItems = (topCause: { title: string; ntees: Array<any> }) => (
  <React.Fragment key={topCause.title}>
    <option style={{ color: "blue" }} disabled>
      {topCause?.title}
    </option>
    {topCause?.ntees?.map((ntee, index) => (
      <option key={index + 1} value={JSON.stringify(ntee)}>
        {ntee?.name}
      </option>
    ))}
  </React.Fragment>
);

export default CausePreferences;
